// @ts-check
import React, { Component } from "react"
import { BlockContextConsumer } from "../ContextProviders"

/**
 * @augments {Component<{children: (props: Broadcastable[]) => any}>}
 */
class AvailableBroadcast extends Component {
    // /**
    //  * @param {BlockContext} context
    //  */
    // getProperties = context => {
    //     return context.blockActions.actions
    // }
    render() {
        return (
            <BlockContextConsumer>
                {context => this.props.children(context.broadcast.items)}
            </BlockContextConsumer>
        )
    }
}

export default AvailableBroadcast



// WEBPACK FOOTER //
// ./src/features/editor/broadcast/AvailableBroadcast.js